const y = void 0, d = "MM/dd/yyyy";

export { d as DEFAULT_FORMAT, y as EMPTY_DATE_VAL };
//# sourceMappingURL=index.js.map
